import { v4 as uuid } from "uuid";

export function getDataArray(data, type) {
  if (type === "club") {
    const res = data.map((item) => {
      if (item.type === "blank") return item;
      else return { type: "club", ...item };
    });

    return res;
  }

  const arr = [{ type: "blank", _id: uuid() }];

  for (let i = 0; i < data.length; i++) {
    if (i % 3 === 0 && i !== 0) {
      arr.push({ type: "blank", _id: uuid() });
    }
    arr.push({ type: type, ...data[i] });
  }

  arr.push({ type: "blank", _id: uuid() });

  return arr;
}
